import { Flex } from 'antd'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useRecoilState, useRecoilValue } from 'recoil'
import {
  getTeamGroups,
  getTeamUsers,
  getUserGroupByStudio,
} from '../../../api/aops.api'
import {
  getWatchdogListByStudio,
  getWatchdogListByTeam,
} from '../../../api/watchdog.api'
import { isAopsChiefState, menuSelectedTeam } from '../../../store/aops'
import { trackerBoardRefetchTrigger } from '../../../store/standaloneSchedule'
import { userAuthStatus, userState } from '../../../store/user'
import MemberSelect from '../../schedule/components/MemberSelect'

const StandAloneAdminDashBoard = ({
  onWatchdogClick,
  setGoalList = () => {},
}) => {
  const route = useLocation()?.pathname
  const { id: urlUserId } = useParams()
  const [selectedType, setSelectedType] = useState('team')
  const [userAuth] = useRecoilState(userAuthStatus)
  const [user] = useRecoilState(userState)
  const navigate = useNavigate()
  const [selectedTeamByMenu] = useRecoilState(menuSelectedTeam)
  const [teamGroupId, setTeamGroupId] = useState(null)
  const [studioGroupId, setStudioGroupId] = useState(null)
  const [watchdogList, setWatchdogList] = useState([])
  const refetchTrigger = useRecoilValue(trackerBoardRefetchTrigger)
  const [selectedMember, setSelectedMember] = useState(null)
  const [activeLevel, setActiveLevel] = useState('MEMBER')
  const [isChief] = useRecoilState(isAopsChiefState)
  const [teamUsers, setTeamUsers] = useState([])
  const pathParts = route?.split('/').filter(Boolean) ?? []
  const urlStudio = pathParts[1]
  const urlTeam = pathParts[2]
  const isOnStudioRoute =
    route?.includes('standalone-admin-schedule') && urlStudio && !urlTeam
  const effectiveTeamForData =
    selectedTeamByMenu ?? urlTeam ?? userAuth?.teamName
  const isMyTeam = effectiveTeamForData === userAuth?.teamName
  const isOnIndividualRoute =
    route?.includes('standalone-schedule') &&
    !route?.includes('admin') &&
    pathParts.length >= 4

  const fetchTeamUsers = async (teamGroupId) => {
    const res = await getTeamUsers(teamGroupId)
    const userList = res.map((item) => ({
      id: item.id,
      name: item.name,
      email: item.email,
    }))
    setTeamUsers(userList)
  }

  useEffect(() => {
    setGoalList(watchdogList)
  }, [watchdogList])

  useEffect(() => {
    if (effectiveTeamForData) {
      setSelectedMember(null)
      if (isChief) {
        setActiveLevel('STUDIO')
      } else if (!isMyTeam) {
        setActiveLevel('TEAM')
      } else {
        setActiveLevel('MEMBER')
      }
      fetchTeamGroups()
    }
  }, [effectiveTeamForData, isChief, isMyTeam])

  // 내 팀이고 isChief가 아닐 때만 자신의 정보로 자동 선택 (팀 라우트)
  useEffect(() => {
    if (isMyTeam && !isChief && teamUsers.length > 0 && user && !urlUserId) {
      const currentUser = teamUsers.find((u) => u.id === user.id)
      if (currentUser) {
        setSelectedMember(currentUser)
      } else if (user.id) {
        setSelectedMember({
          id: user.id,
          name: user.name || user.userName,
        })
      }
    }
  }, [isMyTeam, teamUsers, isChief, user, urlUserId])

  // 개인 라우트 진입 시 URL :id에 맞는 팀원으로 selectedMember 동기화 (버튼에 이름 표시)
  useEffect(() => {
    if (isOnIndividualRoute && urlUserId && teamUsers.length > 0) {
      const userFromUrl = teamUsers.find(
        (u) => String(u.id) === String(urlUserId),
      )
      if (userFromUrl) {
        setSelectedMember(userFromUrl)
      } else if (
        urlUserId &&
        user?.id &&
        String(user.id) === String(urlUserId)
      ) {
        setSelectedMember({
          id: user.id,
          name: user.name || user.userName,
        })
      }
    }
  }, [isOnIndividualRoute, urlUserId, teamUsers, user])

  useEffect(() => {
    if (route?.toLowerCase()?.includes('admin')) {
      setSelectedType(isOnStudioRoute ? 'studio' : 'team')
    } else {
      setSelectedType('individual')
    }
  }, [route, isOnStudioRoute])

  const fetchTeamGroups = async () => {
    const res = await getTeamGroups()
    const selectedTeamGroup = res.find(
      (item) => item.name === effectiveTeamForData,
    )
    setTeamGroupId(selectedTeamGroup?.id)
    fetchTeamUsers(selectedTeamGroup?.id)
  }

  // useEffect(() => {
  //   if (effectiveTeamForData) {
  //     fetchTeamGroups()
  //   }
  // }, [effectiveTeamForData])

  // 스튜디오 라우트일 때 studioGroupId 조회
  useEffect(() => {
    if (isOnStudioRoute && urlStudio) {
      getUserGroupByStudio({ studioName: urlStudio })
        .then((res) => {
          if (res?.studioGroupId !== null && res?.studioGroupId !== undefined) {
            setStudioGroupId(res.studioGroupId)
          }
        })
        .catch(() => setStudioGroupId(null))
    } else {
      setStudioGroupId(null)
    }
  }, [isOnStudioRoute, urlStudio])

  const fetchWatchdogList = async () => {
    try {
      if (
        isOnStudioRoute &&
        studioGroupId !== null &&
        studioGroupId !== undefined
      ) {
        const res = await getWatchdogListByStudio(studioGroupId)
        setWatchdogList(res || [])
      } else if (
        !isOnStudioRoute &&
        teamGroupId !== null &&
        teamGroupId !== undefined
      ) {
        const res = await getWatchdogListByTeam(teamGroupId)
        setWatchdogList(res || [])
      } else {
        setWatchdogList([])
      }
    } catch (error) {
      console.log('error::', error)
      setWatchdogList([])
    }
  }

  useEffect(() => {
    if (
      isOnStudioRoute
        ? studioGroupId !== null && studioGroupId !== undefined
        : teamGroupId !== null && teamGroupId !== undefined
    ) {
      fetchWatchdogList()
    } else if (isOnStudioRoute && !studioGroupId) {
      setWatchdogList([])
    }
  }, [isOnStudioRoute, studioGroupId, teamGroupId])

  // refetchTrigger가 변경되면 WatchdogList도 다시 불러오기
  useEffect(() => {
    if (refetchTrigger > 0) {
      if (
        isOnStudioRoute &&
        studioGroupId !== null &&
        studioGroupId !== undefined
      ) {
        getWatchdogListByStudio(studioGroupId)
          .then((res) => setWatchdogList(res || []))
          .catch(() => setWatchdogList([]))
      } else if (
        !isOnStudioRoute &&
        teamGroupId !== null &&
        teamGroupId !== undefined
      ) {
        getWatchdogListByTeam(teamGroupId)
          .then((res) => setWatchdogList(res || []))
          .catch(() => setWatchdogList([]))
      }
    }
  }, [refetchTrigger, isOnStudioRoute, studioGroupId, teamGroupId])

  return (
    <div className="standalone-admin-dashboard-container">
      <div style={{ flex: 0.4 }}>
        <p className="title"> 그룹 / 개인 선택</p>
        <Flex gap={10}>
          <button
            className={`team-button ${selectedType === 'studio' ? 'active' : ''}`}
            type="button"
            onClick={() => {
              setSelectedType('studio')
              setActiveLevel('STUDIO')
              // setSelectedMember(null)
              navigate(`/standalone-admin-schedule/${userAuth.studioName}`)
            }}
          >
            {userAuth.studioNameKo}
            {' 스튜디오'}
          </button>
          <button
            className={`team-button ${selectedType === 'team' ? 'active' : ''}`}
            type="button"
            onClick={() => {
              setSelectedType('team')
              setActiveLevel(isChief ? 'STUDIO' : isMyTeam ? 'TEAM' : 'TEAM')
              // setSelectedMember(null)
              navigate(
                `/standalone-admin-schedule/${userAuth.studioName}/${userAuth.teamName}`,
              )
            }}
          >
            {userAuth.teamNameKo}
            {'팀'}
          </button>

          <MemberSelect
            placeholder="개인"
            value={
              selectedMember?.id ??
              (isOnIndividualRoute && urlUserId
                ? Number(urlUserId) || urlUserId
                : undefined)
            }
            teamUsers={teamUsers}
            isActive={activeLevel === 'MEMBER' && isOnIndividualRoute}
            setSelectedMember={setSelectedMember}
            setActiveLevel={setActiveLevel}
            currentUser={user}
            isMyTeam={isMyTeam}
            currentTeamName={effectiveTeamForData ?? userAuth?.teamName}
            isOnIndividualRoute={isOnIndividualRoute}
            onChange={(memberId) => {
              if (memberId) {
                setSelectedType('individual')
                navigate(
                  `/standalone-schedule/${userAuth?.studioName}/${userAuth?.teamName}/${memberId}`,
                )
              }
            }}
          />
        </Flex>
      </div>
      <div style={{ flex: 0.6 }}>
        <p className="title"> 금주 Weekly Goal</p>
        <Flex gap={14} style={{ width: '90%' }} justify="flex-start">
          {watchdogList && watchdogList.length > 0 ? (
            watchdogList.map((watchdog) => (
              <div
                key={watchdog.id}
                className="watchdog-item"
                style={{
                  flex: 0.5,
                  cursor: onWatchdogClick ? 'pointer' : undefined,
                }}
                role={onWatchdogClick ? 'button' : undefined}
                tabIndex={onWatchdogClick ? 0 : undefined}
                onClick={(e) => {
                  e.stopPropagation()
                  onWatchdogClick?.(watchdog)
                }}
                onKeyDown={(e) => {
                  if (onWatchdogClick && (e.key === 'Enter' || e.key === ' ')) {
                    e.preventDefault()
                    e.stopPropagation()
                    onWatchdogClick(watchdog)
                  }
                }}
              >
                <div className="vision-board__past-icon">{watchdog.icon}</div>
                <p>{watchdog.title}</p>
              </div>
            ))
          ) : (
            <p style={{ color: '#9ca3af', fontSize: '14px' }}>
              등록된 Weekly Goal이 없습니다.
            </p>
          )}
        </Flex>
      </div>
    </div>
  )
}

export default StandAloneAdminDashBoard
